import "./assets/global.css";
import "./yupLocale";

import { CssBaseline, ThemeProvider } from "@mui/material"; // import themes from 'assets/theme';
import ThemeContext, { IThemeContext, ThemesTypes } from "assets/theme/context";
import Pages from "components/Pages";
import Loader from 'components/Shared/Loader';
import Alert from 'components/Shared/Alert';
import Toast from 'components/Shared/Toast';
import { Suspense, lazy, memo, useEffect, useMemo, useState } from "react";

import PageLoading from "./components/Shared/PageLoading";
import themes from "assets/theme";
import ChatWidget from "components/Shared/Chat";
import { enRoles } from "interfaces/models/core/user/user";
import userService from 'services/user';
import tokenService from "services/token";

const Dialogs = lazy(
  () =>
    import(
      /* webpackChunkName: "Dialogs" */
      /* webpackPrefetch: true */
      "components/Dialogs"
    ),
);

const App = memo(() => {
  const [currentTheme, setCurrentTheme] = useState<ThemesTypes>(
    (localStorage.getItem("app-theme") ?? "light") as ThemesTypes,
  );

  const [canAccessChat, setCanAccessChat] = useState<boolean>(false);

  useEffect(() => {
    tokenService.getToken().subscribe((token) => {
      if(token) {
        userService.current().subscribe((data) => {
          setCanAccessChat(data?.roles?.filter((r) => r == enRoles.accessChat || r == enRoles.sysAdmin).length > 0);
        });
      }
    });
  }, []);

  const themeContext = useMemo<IThemeContext>(() => {
    return {
      currentTheme,
      toogleTheme: (theme?: ThemesTypes) => {
        let newTheme: ThemesTypes = currentTheme === "light" ? "dark" : "light";
        if (theme) {
          newTheme = theme;
        }
        localStorage.setItem("app-theme", newTheme);
        setCurrentTheme(newTheme);
      },
    };
  }, [currentTheme]);

  return (
    <ThemeContext.Provider value={themeContext}>
      <ThemeProvider theme={themes[themeContext.currentTheme]}>
        <Suspense fallback={<PageLoading />}>
          <CssBaseline />
          <Pages />
          <Dialogs />
          <Loader />
          <Alert.Global />
          <Toast.Global />
          {canAccessChat && <ChatWidget />}
        </Suspense>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
});

export default App;
